import React, {useState, useEffect, MouseEventHandler} from 'react';
import {
    Box,
    Container,
    SimpleGrid,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Button,
    chakra,
    useColorModeValue,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
    Flex
} from '@chakra-ui/react';
import { SearchIcon, CloseButton } from '@chakra-ui/icons';
import { useEvoContext } from "../../context/evo.context";
import { Footer } from "../footer/Footer";
import { Header } from "../header/Header";
import { ReadIssueWithImageLink } from "../links/ReadIssueWithImageLink";
import IssuesDataProvider from "../dataProviderEvo/issues-data-provider";
import { ROUTE_MAIN, ROUTE_PURCHASE } from "../../App";
import {JournalTabsInner} from "./JournalListTabs";
import PublicIssuesDataProvider from "../dataProviderEvo/public-issues-data-provider";
import {FormControlEvo} from "../forms/chakra/FormControlEvo";
import {FormLabelEvo} from "../forms/chakra/label/FormLabelEvo";
import {fieldNameAndLabels} from "../../infrastructure/utils/formUtils";

interface Issue {
    id_issue: string;
    title: string;
    header: string;
    year: string;
    date_publish: {
        date: string;
        timezone_type: number;
        timezone: string;
    };
    image: {
        image_url: string;
    }
    pdf: string | null;
    publicCount: number;
    state: {
        code: string;
        value: string;
        page_count: string;
    };
}

type Params = {
    fulltext?: string;
};

export default function JournalListTabsPublic() {
    const [issueData, setIssueData] = useState<Record<string, Issue[]>>({});
    const [searchString, setSearchString] = useState<string>('');
    const [doSearch, setDoSearch] = useState<boolean>(false);
    const [doClearSearch, setDoClearSearch] = useState<boolean>(false);
    const [hasSearched, setHasSearched] = useState<boolean>(false);

    useEffect(() => {
        if (!hasSearched) {
        // if (Object.keys(issueData).length === 0 || doSearch || doClearSearch) {
            const dp = new PublicIssuesDataProvider();

            let params: Params = {};
            if (searchString && searchString !== '') {
                params.fulltext = searchString;
            }

            setHasSearched(true);

            dp.getData(params, {}).then((res) => {
                if (res && res.status === "OK") {

                    const issuesArray = Object.values(res.data).flat() as Issue[];
                    const grouped = issuesArray.reduce<Record<string, Issue[]>>((acc, issue) => {
                        const year = issue.year;
                        if (!acc[year]) acc[year] = [];
                        acc[year].push(issue);
                        return acc;
                    }, {});
                    setIssueData(grouped);
                }
            });
        }
    // }, [issueData, doSearch, doClearSearch]);
    }, [hasSearched]);

    const sortedYears = Object.keys(issueData).sort((a, b) => Number(b) - Number(a));

    const bgColor = useColorModeValue('#f9f9f9', '#1a202c');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setSearchString(value);
    };


    const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setHasSearched(false);
    };

    const handleClear = () => {
        setSearchString('');
        setHasSearched(false);
    };

    const handleKeyDown = (e : any) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };


    return (
        <>
                <Box bg={bgColor}>
                    <Header />
                    <Container maxW={'8xl'}>
                        <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                            Archiv vydání
                        </chakra.h1>

                        {/*<Box padding={"10"}>*/}
                        {/*    <Flex>*/}
                        {/*        <InputGroup flex="1">*/}
                        {/*            <InputLeftElement pointerEvents="none">*/}
                        {/*                <SearchIcon color="gray.400" />*/}
                        {/*            </InputLeftElement>*/}

                        {/*            <Input*/}
                        {/*                value={searchString}*/}
                        {/*                type={'text'}*/}
                        {/*                name={'search'}*/}
                        {/*                onInput={handleChange}*/}
                        {/*                onKeyDown={handleKeyDown}*/}
                        {/*                placeholder="Search..."*/}
                        {/*            />*/}

                        {/*            <InputRightElement>*/}
                        {/*                {searchString && (*/}
                        {/*                    <CloseButton onClick={handleClear} />*/}
                        {/*                )}*/}
                        {/*            </InputRightElement>*/}
                        {/*        </InputGroup>*/}

                        {/*        <Button*/}
                        {/*            colorScheme="pink"*/}
                        {/*            onClick={handleSubmit}*/}
                        {/*            ml={2}*/}
                        {/*        >*/}
                        {/*            Search*/}
                        {/*        </Button>*/}
                        {/*    </Flex>*/}
                        {/*</Box>*/}
                        {Object.keys(issueData).length > 0 && (<JournalTabsInner sortedYears={sortedYears} issueData={issueData}/>)}
                        {Object.keys(issueData).length == 0 && (<Box paddingTop={"20"}  paddingBottom={"20"} textAlign={"center"}>{"Nebyl nalezen žádný časopis"}</Box>)}
                    </Container>
                    <Footer />
                </Box>
        </>
    );
}
